$ = require 'jquery'
qs = require 'query-string'

class Router
  queryParams: ->
    return qs.parse(window.location.search)

  nojs: ->
    variables = qs.parse(window.location.search)
    return variables.nojs == '1'

  test: ->
    variables = qs.parse(window.location.search)
    return variables.test == '1'

  server: ->
    loc = window.location.href
    if /ttv_personal_22/.test(loc) or /ttv_mw_22/.test(loc)
      return 'test'
    return 'prod'

  site: ->
    loc = window.location.href
    if /online\.tourtrans\.ru/.test(loc)
      return 'online'
    if /personal\.tourtrans\.ru/.test(loc)
      return 'personal'
    if /ttv_personal_22/.test(loc)
      return 'personal'
    if /ttv_mw_22/.test(loc)
      return 'online'

  page: ->
    pageType = false
    r = window.location.href.match /\/([^\/]*?).aspx/
    if r && r.length > 0
      pageType = r[1]
      if pageType.toLowerCase() == 'orderlist'
        hash = window.location.hash
        if hash.length > 1
          pageType = hash.substr(1)
        else
          pageType = 'OrderList'
      if pageType.toLowerCase() == 'orderinfo'
        pageType = 'OrderInfo'
      if pageType.toLowerCase() == 'personalregistration'
        pageType = 'PersonalRegistration'
      if pageType.toLowerCase() == 'personalpage'
        pageType = 'PersonalPage'
      console.log 'Тип определен: ', pageType
    else
      console.error('Тип не определен:', window.location.href)
      throw new Error('Тип не определен:' + window.location.href)

    pageType

  setBodyClasses: ->
    classes = []
    classes.push @site()
    pageType = @page()
    page_type = pageType.replace /(?:^|\.?)([A-Z])/g, (x,y) ->
      return "_" + y.toLowerCase()
    .replace(/^_/, "")
    classes.push page_type
    $('body').removeClass().addClass(classes.join(' '))


module.exports = new Router
